import React, { useContext } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { token, user, loading } = useContext(AuthContext);
  const location = useLocation();

  if (loading) return <div style={{ padding: 24 }}>Loading...</div>;
  const isAuthed = Boolean(token) || Boolean(user && (user._id || user.id || user.userId));
  if (!isAuthed) return <Navigate to="/login" replace state={{ from: location }} />;
  return children;
}
